import React, { useState } from 'react';
import { TextField, Button } from '@mui/material';
import { isConcealedSecret } from '../sftpFileFeedConfig';

export const SavedSecretField = ({
  label,
  secret,
  onChange,
  required = true,
  multiline = false,
  helperText
}) => {
  const saved = isConcealedSecret(secret);
  const [replacing, setReplacing] = useState(false);
  const [previous, setPrevious] = useState(null);

  if (saved && !replacing) {
    return (
      <TextField
        fullWidth
        helperText="Saved securely. It is not shown again. Replace it to enter a new value."
        label={label}
        placeholder="••••••••"
        type="password"
        value=""
        variant="standard"
        InputProps={{
          readOnly: true,
          endAdornment: (
            <Button
              onClick={() => {
                setPrevious(secret);
                setReplacing(true);
              }}
              size="small"
            >
              Replace
            </Button>
          )
        }}
      />
    );
  }

  const shown = typeof secret === 'string' ? secret : '';
  return (
    <TextField
      fullWidth
      helperText={
        helperText ||
        'Stored encrypted when the job is saved, and not shown again.'
      }
      label={label}
      multiline={multiline}
      onChange={(e) => {
        const next = e.target.value;
        if (next === '' && previous) {
          onChange(previous);
          setReplacing(false);
          setPrevious(null);
          return;
        }
        onChange(next);
      }}
      required={required}
      type={multiline ? 'text' : 'password'}
      value={shown}
      variant="standard"
      autoComplete="new-password"
    />
  );
};
